@let alertInstance = model.alertInstance$();
@let mode = model.mode$();

<div *ngIf="alertInstance" class="alert-instance" data-link-ga-node="AlertInstance" [attr.data-link-ga-details]="{'alertTitle': alertInstance?.title, 'alertSource': alertInstance?.source} | json">
  <div class="alert-header">
    <div class="left-section d-flex align-items-center">
      @if(mode === 'list') {
        <div class="alert-time">
          <i class="pi pi-clock"></i>
          <span>{{model.duration$()}} ago</span>
        </div>
      }
    </div>
    <div class="right-section d-flex align-items-center" data-link-ga-node="CloseButton">
      @if(mode === 'toast') {
        <i class="close-icon pi pi-minus-circle" (click)="closeClicked($event)"></i>
      }
      @else if(mode === 'list') {
        <i class="close-icon pi pi-times-circle" (click)="closeClicked($event)"></i>
      }
    </div>
  </div>

  <div class="block-wrapper" data-link-ga-node="Selection">
    <div (click)="handle('AlertSelection'); selected($event)" [class]="'alert-title severity-' + alertInstance.severity">
      {{alertInstance.title}}
    </div>
  </div>

  <div *ngIf="alertInstance.source" class="block-wrapper" data-link-ga-node="Selection">
    <div (click)="handle('AlertSelection'); selected($event)" class="alert-source">
      {{alertInstance.source}}
    </div>
  </div>
</div>
